// src/Lexapp/AppsLoader.jsx
import React, { useEffect, useState } from 'react';
import { useParams }                  from 'react-router-dom';
import { collection, getDocs }        from 'firebase/firestore';
import { db }                         from '../firebase';

export default function AppsLoader() {
  const { appId } = useParams();
  const [app, setApp]      = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const snap = await getDocs(collection(db, 'apps'));
      const found = snap.docs
        .map(d => d.data())
        .find(a => a.appId === appId);
      setApp(found || undefined);
      setLoading(false);
    }
    load();
  }, [appId]);

  if (loading)         return <div>Loading…</div>;
  if (!app)            return <div>App “{appId}” not found.</div>;
  if (!app.entryPoint) return <div>No entry point configured.</div>;

  return (
    <iframe
      src={app.entryPoint}
      style={{ width: '100%', height: '100vh', border: 0 }}
      title={appId}
    />
  );
}
